import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLang } from "@/context/LanguageContext";

const FAQ = () => {
  const { t } = useLang();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-16 md:py-32 relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-x-0 top-0 h-96 pointer-events-none opacity-50"
        style={{
          background:
            "radial-gradient(60% 50% at 50% 0%, rgba(212,111,77,0.08), rgba(212,111,77,0) 70%)",
        }}
      />
      <div className="relative max-w-4xl mx-auto px-6 md:px-10">
        <div className="mb-14">
          <div className="eyebrow">{t.faq.eyebrow}</div>
          <h2 className="mt-4 font-display font-light text-4xl md:text-5xl tracking-tight text-maif">
            {t.faq.title}
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="rounded-2xl border border-sand-soft bg-maif-2 px-6 md:px-8"
          data-testid="faq-accordion"
        >
          {t.faq.items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-sand-soft last:border-b-0"
            >
              <AccordionTrigger className="py-6 text-left font-display text-lg md:text-xl text-maif tracking-tight hover:no-underline data-[state=open]:text-terracotta">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-maif-muted text-base leading-relaxed">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
